import Cookies from "js-cookie";
import * as MutationType from '../mutation-types'

const state = {
  sidebar: {
    // opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    opened: true,
    withoutAnimation: false
  }
};

const mutations = {
  [MutationType.TOGGLE_SIDEBAR]: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  [MutationType.CLOSE_SIDEBAR]: (state, withoutAnimation) => {
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
    Cookies.set('sidebarStatus', 0);
  }
}

const actions = {
  toggleSidebar({ commit }) {
    commit(MutationType.TOGGLE_SIDEBAR)
  },
  closeSidebar({ commit }, { withoutAnimation }) {
    commit(MutationType.CLOSE_SIDEBAR, withoutAnimation)
  },
}

//  "wrap_attributes": "force-expand-multiline"

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js